import { AppEntity, ContactPersonId, ContactTypeEnum } from '@app/icare/db/schema/common'
import f from '@app/icare/db/schema/field/f'
import type { Doctor } from '@app/icare/entities/doctor/schema/Doctor'
import { DoctorId } from '@app/icare/entities/doctor/schema/Doctor'
import { PrescriberStatusSchema } from '@app/icare/entities/patient/schema/common/PatientPrescriber'
import type { WithRestoredPatientRelations } from '@app/icare/entities/patient/schema/Patient'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'
import { PatientRelation } from './PatientRelation'

export const PatientDoctorId = entityId('patientDoctor')

export type PatientDoctorIdType = typeof PatientDoctorId.Type

export const PatientDoctorRelationSchema = PatientRelation.extend({
  id: PatientDoctorId.schema,
  toId: DoctorId.ref,
  prescriber: PrescriberStatusSchema.nullish(),
  primaryDoctor: z.object({
    active: z.boolean().nullish(),
  }),
  comment: z.string().nullish(),
})

export type PatientDoctorRelation = z.infer<typeof PatientDoctorRelationSchema>

export type PatientDoctorRestoredRelation = WithRestoredPatientRelations<PatientDoctorRelation, Doctor>

export const PatientDoctorContactPersonId = entityId('patientDoctorContactPerson')

export const PatientDoctorContactPersonSchema = AppEntity.extend({
  id: PatientDoctorContactPersonId.schema,
  ownerId: PatientDoctorId.ref,
  contactPersonId: ContactPersonId.ref,
  contactType: z.enum(ContactTypeEnum.$.enum),
})

export type PatientDoctorContactPerson = z.infer<typeof PatientDoctorContactPersonSchema>
